import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PROFILE_ELIGIBILITY_HEALTHPLAN } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetProfileEligibilityHealthPlanResult } from '../types/getProfileEligibilityHealthPlan.types';

export const TAG_PE_HEALTHPLAN = 'PEHealthPlan';

export const getProfileEligibilityHealthPlan = (builder: BuilderType) =>
  builder.query<GetProfileEligibilityHealthPlanResult, void>({
    providesTags: [TAG_PE_HEALTHPLAN],
    query: () => ({
      data: {},
      method: 'POST',
      url: GET_PROFILE_ELIGIBILITY_HEALTHPLAN,
    }),
    transformResponse: (response: GenericApiResponse<GetProfileEligibilityHealthPlanResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
